import React, { useEffect, useState } from 'react';

export default function LoadingScreen() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const duration = 1800;
    const interval = 20;
    const steps = duration / interval;
    let current = 0;

    const timer = setInterval(() => {
      current++;
      // Ease-out: fast start, slows near end
      const pct = 1 - Math.pow(1 - current / steps, 3);
      setProgress(Math.min(Math.round(pct * 100), 100));
      if (current >= steps) clearInterval(timer);
    }, interval);

    return () => clearInterval(timer);
  }, []);

  return (
    <div style={{
      position: 'fixed', inset: 0,
      background: '#0d1117',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      zIndex: 9999,
    }}>
      {/* Logo Icon */}
      <div style={{
        width: 72, height: 72,
        background: 'linear-gradient(135deg, #1a6b5c 0%, #0ea88a 100%)',
        borderRadius: 18,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        marginBottom: 20,
        boxShadow: '0 0 40px rgba(14, 168, 138, 0.35)',
      }}>
        {/* IV Drip Icon */}
        <svg width="38" height="38" viewBox="0 0 38 38" fill="none">
          {/* Bag */}
          <rect x="11" y="3" width="16" height="13" rx="4" fill="white" opacity="0.95"/>
          {/* Bag highlight */}
          <rect x="13" y="5" width="5" height="3" rx="1.5" fill="white" opacity="0.4"/>
          {/* Drip tube */}
          <line x1="19" y1="16" x2="19" y2="22" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          {/* Drip chamber */}
          <rect x="15.5" y="22" width="7" height="5" rx="2" fill="white" opacity="0.8"/>
          {/* Lower tube */}
          <line x1="19" y1="27" x2="19" y2="33" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          {/* Needle tip */}
          <path d="M16 33 Q19 36 22 33" stroke="white" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
          {/* Drop */}
          <ellipse cx="19" cy="19.5" rx="1.2" ry="1.5" fill="#0ea88a"/>
        </svg>
      </div>

      {/* App Name */}
      <div style={{
        color: '#ffffff',
        fontSize: 28,
        fontWeight: 700,
        letterSpacing: '-0.5px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        marginBottom: 6,
      }}>
        IVPilot
      </div>

      {/* Tagline */}
      <div style={{
        color: 'rgba(255,255,255,0.4)',
        fontSize: 13,
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        marginBottom: 36,
        letterSpacing: '0.3px',
      }}>
        Clinic Management Platform
      </div>

      {/* Progress Bar */}
      <div style={{
        width: 200,
        height: 3,
        background: 'rgba(255,255,255,0.08)',
        borderRadius: 99,
        overflow: 'hidden',
      }}>
        <div style={{
          height: '100%',
          width: `${progress}%`,
          background: 'linear-gradient(90deg, #0ea88a, #00d4aa)',
          borderRadius: 99,
          transition: 'width 20ms linear',
          boxShadow: '0 0 8px rgba(14, 168, 138, 0.6)',
        }} />
      </div>
    </div>
  );
}
